import { render, staticRenderFns } from "./NewPrAffiliate.vue?vue&type=template&id=ef65a6a6&scoped=true&"
import script from "./NewPrAffiliate.ts?vue&type=script&lang=ts&"
export * from "./NewPrAffiliate.ts?vue&type=script&lang=ts&"
import style0 from "./NewPrAffiliate.scss?vue&type=style&index=0&id=ef65a6a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef65a6a6",
  null
  
)

export default component.exports